// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6e3b3064","821":"278ceb29"}[chunkId] + ".chunk.js";
};